import React, { memo, useMemo } from 'react';
import Lottie from 'lottie-react';

interface LottieIllustrationProps {
  animationData: any;
  className?: string;
  width?: number | string;
  height?: number | string;
  loop?: boolean;
  autoplay?: boolean;
  rendererSettings?: any;
}

const LottieIllustration: React.FC<LottieIllustrationProps> = memo(({ 
  animationData, 
  className = '', 
  width = '100%', 
  height = '100%',
  loop = true,
  autoplay = true,
  rendererSettings
}) => {
  const optimizedRendererSettings = useMemo(() => ({
    preserveAspectRatio: 'xMidYMid slice',
    progressiveLoad: true,
    hideOnTransparent: true,
    ...rendererSettings
  }), [rendererSettings]);

  const containerStyle = useMemo(() => ({
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height
  }), [width, height]);

  if (!animationData) {
    return null;
  }

  return (
    <div className={`flex items-center justify-center ${className}`} style={containerStyle}>
      <Lottie
        animationData={animationData}
        loop={loop}
        autoplay={autoplay}
        rendererSettings={optimizedRendererSettings}
        style={{ 
          width: '100%', 
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%'
        }}
      />
    </div>
  );
});

export default LottieIllustration;
